



















if (
  ~location.host.indexOf("172.16.27.26") ||
  ~location.host.indexOf("10.0.58.47") ||
  // ~location.host.indexOf("localhost") ||
  ~location.host.indexOf("-dev") ||
  ~location.host.indexOf("-test")
) {
  // @ts-ignore
  eruda.init();
}
console.log("origin token : ", localStorage.getItem("token"), 1);

import "@/preset/rem";
import MobileApp, { inAndroidApp, inIOSApp } from "./utils/mobile/MobileApp";
window.nativeApp = new MobileApp();
import "@/preset/app-init";

import WtHeader from "@/components/base/WtHeader.vue";
import { Component } from "vue-property-decorator";
import {
  setBottomHeightVariable,
  setHeaderHeightVariable
} from "@/utils/header";
import { setPlatformTheme } from "@/utils/project";
import { refreshForApp } from "@/utils/mall/refresh";
import WtTabBar from "@/components/base/WtTabBar.vue";
import { AppStore } from "@/store/namespace";
import { unusedTokenRoutes, includeStatusBarRoutes } from "@/router";
import { mixins } from "vue-class-component";
import PageTransitionMx from "@/mixins/page/PageTransitionMx";
import { getToken } from "@/utils/request";
import { hasMatchRoute } from "@/utils/router";

// 优先注册
window.refreshHomePage = () => {};

@Component({
  components: {
    WtHeader,
    WtTabBar
  }
})
export default class App extends mixins(PageTransitionMx) {
  @AppStore.State platform: string;
  @AppStore.State cacheRoutes: any[];
  @AppStore.Action getPlatformAction: Function;

  get showHeader() {
    return !!(this.$route.meta?.showHeader || this.$route.query?.header);
  }

  async created() {
    // 初始化
    window.nativeApp.canGoBack("1");
    console.log(location.href, navigator.userAgent);
    // 注册全局方法
    window.refreshForApp = refreshForApp;
    await getToken();
    if (!hasMatchRoute(this.$router, unusedTokenRoutes, location.pathname)) {
      await this.getPlatformAction();
    }

    const hasCurrentRoute = hasMatchRoute(
      this.$router,
      includeStatusBarRoutes,
      location.pathname
    );
    setHeaderHeightVariable(
      !(inIOSApp() || (inAndroidApp() && !!hasCurrentRoute))
    );
    setBottomHeightVariable();
    setPlatformTheme(this.platform);
  }
}
